// src/components/ProtectedRoute/ProtectedRoute.jsx
import React from 'react'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from 'store/auth.store'

const ProtectedRoute = () => {
  const { isLoggedIn, token, user } = useAuthStore()
  const location = useLocation()

  // 1. If not authenticated, redirect to sign-in page
  if (!isLoggedIn || !token || !user) {
    return <Navigate to='/auth/sign-in' replace />
  }

  const role = user?.role ? String(user.role).trim().toLowerCase() : ''

  // 2. STRICT GATE KEEPER ISOLATION:
  // Gate Keeper users are strictly restricted to the scanner terminal (/gatekeeper/check-in).
  // Any attempt to access /admin/* or any other path redirects directly to /gatekeeper/check-in.
  if (role === 'gate_keeper') {
    if (!location.pathname.startsWith('/gatekeeper')) {
      return <Navigate to='/gatekeeper/check-in' replace />
    }
  }

  // 3. STRICT ADMIN ISOLATION:
  // Admin users navigating to /gatekeeper are directed to their integrated Admin check-in view.
  if (role === 'admin') {
    if (location.pathname.startsWith('/gatekeeper')) {
      return <Navigate to='/admin/check-in' replace />
    }
  }

  // 4. Any unexpected or unknown role
  if (role !== 'admin' && role !== 'gate_keeper') {
    return <Navigate to='/auth/sign-in' replace />
  }

  return <Outlet />
}

export default ProtectedRoute
